import { useContentfulFormSchema } from '~/services/origins';
import type { ContentfulOrigin, UseContentfulFormSchema } from '~/services/origins';

type OriginTypes = ContentfulOrigin;
type SchemaHooks = Record<OriginTypes, UseContentfulFormSchema>;

export interface Origin {
  from: OriginTypes;
  value: string;
}

export const useFormSchema = ({ from, value }: Origin) => {
  const SCHEMA_HOOKS: SchemaHooks = {
    Contentful: useContentfulFormSchema,
  };

  return SCHEMA_HOOKS[from](value);
};
